var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 240H122C98.812 240 80 258.812 80 282V320H144V240ZM80 390C80 413.188 98.812 432 122 432H208V352H80V390ZM176 320H304V282C304 258.812 285.188 240 262 240H176V320ZM374.627 118.627L265.373 9.373C259.371 3.371 251.232 0 242.746 0H64C28.801 0 0 28.799 0 64V448C0 483.199 28.801 512 64 512H320C355.199 512 384 483.199 384 448V141.254C384 132.768 380.629 124.629 374.627 118.627ZM336 448C336 456.75 328.75 464 320 464H64C55.25 464 48 456.75 48 448V64C48 55.25 55.25 48 64 48H236.125L336 147.875V448ZM240 432H262C285.188 432 304 413.188 304 390V352H240V432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCard);
export default __webpack_public_path__ + "static/media/sim-card.819d20734edc499870726e463cb57dbe.svg";
export { ForwardRef as ReactComponent };